import { Box, BoxProps } from '@chakra-ui/react';

const SidebarIcon = ({ children }: BoxProps) => (
  <Box color="inherit" fontSize={28} mr={5}>
    {children}
  </Box>
);

export default SidebarIcon;
